import * as React from 'react';
import { connect } from 'react-redux';
import { CAR_DETAILS, CAR_REGISTRATION, SALES_ADDRESS } from '../../../routes/routes';
import { ProgressBar, Form, Image, Button, Dropdown } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { CarRegistrationCheck, setFinanceHouse } from '../../../actions/salesActions';
import './VehicleLookup.css';
import { postToController } from '../../../actions/apiActions';

class VehicleLookup extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            regNo: "",
            lookupCorrect: false,
            loggedIn: this.props.auth.uid ? true : false,
            hasSelectedFinance: false,
            financeHouseList: [],
            nextDisabled: true,
            openDisabled: true,
            selectedFinanceHouse: "",
            selectedFinanceHouseId: -1,
            selectedFinanceHouseDropdown: false,
            buttonYesClicked: false,
            buttonNoClicked: false,
            isFinanceYes: false,
        }

        this.handleYesYouveGotIt = this.handleYesYouveGotIt.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCloseButNo = this.handleCloseButNo.bind(this);

        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.getFinanceHouses = this.getFinanceHouses.bind(this);
        this.handleFinanceSelection = this.handleFinanceSelection.bind(this);
        this.handleSelectedFinanceHouseDropdownToggle = this.handleSelectedFinanceHouseDropdownToggle.bind(this);
        this.handleYesButton = this.handleYesButton.bind(this);
        this.handleNoButton = this.handleNoButton.bind(this);
    }

    async componentDidMount() {
        if (this.state.financeHouseList.length === 0) {
            await this.getFinanceHouses();
        }
    }

    async handleBack(e: any) {
        await this.setState({ lookupCorrect: false });
        this.props.redirectTo(CAR_REGISTRATION)
    }

    async handleYesYouveGotIt() {
        await this.setState({ lookupCorrect: true});
    }

    handleCloseButNo() {
        this.props.sales.vehicleFullDescription = "";
        this.props.sales.vehicleYear = "";
        this.props.redirectTo(CAR_DETAILS)
    }

    async handleYesButton() {
        await this.setState({ hasSelectedFinance: true });
        await this.setState({ openDisabled: false, buttonNoClicked: false, nextDisabled: true, buttonYesClicked: true, isFinanceYes: true });
    }

    async handleNoButton() {
        await this.setState({ hasSelectedFinance: true });
        await this.setState({ openDisabled: true, buttonNoClicked: true, nextDisabled: false, buttonYesClicked: false, isFinanceYes: false });
    }

    async handleNext() {
        if (this.state.selectedFinanceHouse !== "" && this.state.selectedFinanceHouseId !== -1) {
            this.props.dispatchSetFinanceHouse(this.state.selectedFinanceHouse,this.state.selectedFinanceHouseId);
        }
        this.props.redirectTo(SALES_ADDRESS);
    }

    async handleFinanceSelection(e: any) {
        await this.setState({ nextDisabled: false });
        let coverItem = this.state.financeHouseList.filter(function (item) {
            return item.id == e
        })
        await this.setState({
            selectedFinanceHouse: coverItem[0].description,
            selectedFinanceHouseId: coverItem[0].id,
        });

    }

    async getFinanceHouses() {
        await postToController(this.props.dispatch, 'GetFinanceHouses', JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            let countryId = this.props.profile.countryId;
            let list = response.filter(function (item) { return item.countryId === countryId });
            await this.setState({ financeHouseList: list });
            return true;
        })
    }

    async handleSelectedFinanceHouseDropdownToggle(e: any) {
        await this.setState({
            selectedFinanceHouseDropdown: !this.state.selectedFinanceHouseDropdown
        });
    }

    public render() {
        let financeHouseDrop = [];
        if (this.state.financeHouseList.length > 0) {
            financeHouseDrop = this.state.financeHouseList.map((item) => {
                return <Dropdown.Item key={item.id} eventKey={item.id}>{item.description}</Dropdown.Item>
            });
        }

        return (
            <div className={this.state.loggedIn ? "pt-1 logged-in" : "pt-1 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></Button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></Button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={30} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div>
                                    <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">This is what we managed to find under your registration number</p>
                                </div>
                                <div className="form-row mb-lg-1 mb-2">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <Form.Label className={'left-align temp-text-box-label pl-1' + (this.props.sales.vehicleYear !== "" ? "" : " no-opacity")}>Year</Form.Label>
                                            <Form.Control type="text" placeholder="Year" id="YearInputId" name="year" value={this.props.sales.vehicleYear} disabled={this.props.sales.vehicleYear !== "" ? true : false} />
                                        </div>
                                    </div>
                                    <div className="col-12 mt-3">
                                        <div className="form-group">
                                            <Form.Label className={'left-align temp-text-box-label pl-1' + (this.props.sales.vehicleFullDescription !== "" ? "" : " no-opacity")}>Make and model</Form.Label>
                                            <Form.Control type="text" placeholder="Make and model" id="DescriptionInputId" name="description" value={this.props.sales.vehicleFullDescription} disabled />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row d-flex justify-content-center mt-lg-4">
                                    <div className="col-md-6 col-xl-4 col-12 text-right">
                                        <button type="submit" className="btn btn-outline-red mt-3 mt-lg-0 w-100 cursor-pointer" id="CloseButNoButton" onClick={this.handleCloseButNo}>Close, but no</button>
                                    </div>
                                    <div className="col-md-6 col-xl-4 col-12">
                                        <button type="submit" className="btn btn-block btn-solid-red mt-3 mt-lg-0 cursor-pointer" id="YesGotItButton" onClick={this.handleYesYouveGotIt}>Yes, you’ve got it</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 mt-2 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-12">
                                <div>
                                    <p className="mt-2 text-center Lets-get-to-know-ea">Is your car already financed</p>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <div className="col-md-2 col-6">
                                        <button disabled={!this.state.lookupCorrect } className={this.state.buttonYesClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnYes" onClick={this.handleYesButton}>Yes</button>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <button disabled={!this.state.lookupCorrect} className={this.state.buttonNoClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnNo" onClick={this.handleNoButton}>No</button>
                                    </div>
                                </div>

                                <div className="col-12 p-0 mt-5">
                                    <p className={this.state.isFinanceYes ? 'text-left mb-1' : 'text-left mb-1 p-disabled'}><b>Where is it financed</b></p>
                                    <Dropdown
                                        id="financeHouse-select-dropdown"
                                        className="fit-full"
                                        onSelect={this.handleFinanceSelection}
                                        onToggle={this.handleSelectedFinanceHouseDropdownToggle}>
                                        <Dropdown.Toggle id="dropdown-basic" disabled={this.state.openDisabled}>
                                            <div className="row dropdown-height">
                                                <div className="dropdown-basic-title-text col-11">
                                                    {this.state.selectedFinanceHouse}
                                                    {!this.state.selectedFinanceHouse &&
                                                        <p>Choose an option</p>
                                                    }
                                                </div>
                                                <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'visible' : 'invisible'} alt="" />
                                                <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'invisible' : 'visible'} alt="" />
                                            </div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu id='financeHouseDropDown'>
                                            {financeHouseDrop}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <div className="row justify-content-center">
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                        <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleNext}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCarRegistration: (regNr: any) => dispatch(CarRegistrationCheck(regNr)),
        dispatchSetFinanceHouse: (FinanceHouse: any, FinanceHouseId : number) => dispatch(setFinanceHouse(FinanceHouse,FinanceHouseId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleLookup);